import { render, staticRenderFns } from "./ProductImageCarousel.vue?vue&type=template&id=8e61bd5e&scoped=true&"
import script from "./ProductImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e61bd5e",
  null
  
)

export default component.exports